import { VictorCurrencies } from 'fortune-client';

export const API_URL = window.vicConfig.apiUrl;
export const OAUTH2_CLIENT_ID = window.vicConfig.oauth2ClientId;
export const OAUTH2_CLIENT_SECRET = window.vicConfig.oauth2ClientSecret;
export const CURRENCIES: VictorCurrencies[] = ['USD', 'EUR', 'GBP', 'AED'];
